import React, {useRef, useState} from 'react'
import AuthenticationAPI from "../../../services/AuthenticationAPI";
import Links from "../../../Route";

const PasswordForgotten = () => {

    let message = "";
    const
        alertMessage = (message, type) => {
            return <div className={"alert alert-" + type}>{message}</div>;
        },

        [alertElement, setAlertElement] = useState(message),

        [email, setEmail] = useState(""),

        [isPasswordReset, setPasswordReset] = useState(false),

        [isFormSubmitted, setFormSubmitted] = useState(false),

        submitButtonRef = useRef(null),

        handleChange = ({currentTarget}) => {
            const {value} = currentTarget;
            setEmail(value);
        },

        handleSubmit = async (event) => {
            event.preventDefault();
            setFormSubmitted(true);

            try {
                const
                    response = await AuthenticationAPI.passwordForgotten(email),
                    message = AuthenticationAPI.response && AuthenticationAPI.response.message ? AuthenticationAPI.response.message : "Réessayer ultérieurement!"
                ;

                setAlertElement(alertMessage(message, response !== true ? "danger" : "success"));

                setFormSubmitted(response);

                setPasswordReset(response);

            }
            catch (error){console.log(error)}
        }
    ;

    return (
        <>
            <div className="inner-head bg-animate">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-md-8 col-md-offset-2">
                            <h3>{Links.PasswordForgotten.label}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="clearfix"></div>
            <div className="inner-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            {alertElement}

                            {
                                isPasswordReset ? "" : (
                                    <form onSubmit={handleSubmit}>
                                        <div className="clearfix"></div>
                                        <ul className="listForm">
                                            <li className="full-list">
                                                <label>Email :</label>
                                                <input className="form-control input-email input-lg" required type="text" name="email" onChange={handleChange} />
                                            </li>
                                            <li className="full-list last-list">
                                                {
                                                    isFormSubmitted ?
                                                        <input type="button" value="Waiting..." className="btn btn-primary btn-lg btn-block" disabled name="disabled"/>
                                                        :
                                                        <input type="submit" ref={submitButtonRef} value="Envoyer le mail de réinitialisation" className="btn btn-primary btn-lg btn-block" name="submit"/>
                                                }
                                            </li>
                                        </ul>
                                    </form>
                                )
                            }
                        </div>
                        <div className="col-md-2"></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordForgotten;